export const METADATA_FUNCTION_URL = 'https://qkesv6w72hzjc6khb6rykjveiu0tiont.lambda-url.us-east-2.on.aws';
export const PRESIGNED_FUNCTION_URL = 'https://gsg2u3gudiatu2budtjexeawza0qplth.lambda-url.us-east-2.on.aws';
